module.exports = __webpack_public_path__ + "img/group25@2x-英语.d80c5941.png";